<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col sm="12">
             <h4 id="traffic" class="card-title mb-0">Absensi</h4><br/>
        </b-col>
      </b-row>
      <template v-if="!loading">
      <b-row>
        <b-col sm="2" style="padding-right: 0px">
            <b-form-select
              id="month"
              :options="listMonth"
              v-model="currentMonth"
              placeholder="-- Harap pilih salah satu --"
              required
            ></b-form-select>
        </b-col>
        <b-col sm="1" style="padding-right: 0px">
            <b-form-select
              id="year"
              :options="listYear"
              v-model="currentYear"
              placeholder="-- Harap pilih salah satu --"
              required
            ></b-form-select>
        </b-col>
        <b-col lg="3" style="padding-right: 0px">
          <b-button
            variant="stack-overflow"
            class="mr-1 btn-brand"
            @click="init"
          >
            <i class="fa fa-search"></i>
          </b-button>
        </b-col>
      </b-row>
    
      <line-example
        :key="uniqueId('line-attendance-1')"
        :line-label="employee_attendance.label"
        :line-data="employee_attendance.dataset"
        chartId="chart-line-01"
        :height="isMobile"
      ></line-example>
      </template>

      <loading v-else></loading>
    </b-card>

    <b-card>
      <b-row>
        <b-col sm="12">
             <h4 id="traffic" class="card-title mb-0">Absensi Yang Di Verifikasi</h4><br/>
        </b-col>
      </b-row>
      <template v-if="!loading">
      <b-row>
        <b-col sm="2" style="padding-right: 0px">
            <b-form-select
              id="month"
              :options="listMonth2"
              v-model="currentMonth2"
              placeholder="-- Harap pilih salah satu --"
              required
            ></b-form-select>
        </b-col>
        <b-col sm="1" style="padding-right: 0px">
            <b-form-select
              id="year"
              :options="listYear2"
              v-model="currentYear2"
              placeholder="-- Harap pilih salah satu --"
              required
            ></b-form-select>
        </b-col>
        <b-col lg="3" style="padding-right: 0px">
          <b-button
            variant="stack-overflow"
            class="mr-1 btn-brand"
            @click="attendanceVerification"
          >
            <i class="fa fa-search"></i>
          </b-button>
        </b-col>
      </b-row>

      <bar-example
        :key="uniqueId('line-attendance-2')"
        :bar-label="employee_attendance_verified.label"
        :bar-data="employee_attendance_verified.dataset"
        chartId="chart-bar-02"
        :height="isMobile"
        @openVerificationDetail="openVerificationDetail"
      ></bar-example>
      </template>

      <loading v-else></loading>
    </b-card>

    <b-card-group class="mb-4">
      <b-card>
        <div class="h4 text-muted text-right mb-4">
          <i class="icon-people"></i>&nbsp;Status Karyawan
        </div>
        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('doughnut-cro')"
            :doughnut-label="total_employee.label"
            :doughnut-data="total_employee.data"
            chartId="chart-doughnut-01"
          ></doughnut-example>
          <br />
          <table-total :tableData="total_employee" :title="'total_employee'"></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
      <b-card>
        <div class="h4 text-muted text-right mb-4">
          <i class="icon-people"></i>&nbsp;Jenis Gaji Karyawan
        </div>
        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('doughnut-cro')"
            :doughnut-label="employee_payment_method.label"
            :doughnut-data="employee_payment_method.data"
            chartId="chart-doughnut-01"
          ></doughnut-example>
          <br />
          <table-total :tableData="employee_payment_method" :title="'employee_payment_method'"></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
      <b-card>
        <div class="h4 text-muted text-right mb-4">
          <i class="icon-people"></i>&nbsp;Umur Kontrak Kerja
        </div>
        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('doughnut-cro')"
            :doughnut-label="employee_contract.label"
            :doughnut-data="employee_contract.data"
            chartId="chart-doughnut-01"
          ></doughnut-example>
          <br />
          <table-total :tableData="employee_contract" :title="'employee_contract'"></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
      <b-card>
        <div class="h4 text-muted text-right mb-4">
          <i class="icon-people"></i>&nbsp;Kehadiran Karyawan
        </div>
        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('doughnut-cro')"
            :doughnut-label="employee_attendance_status.label"
            :doughnut-data="employee_attendance_status.data"
            chartId="chart-doughnut-01"
          ></doughnut-example>
          <br />
          <table-total :tableData="employee_attendance_status" :title="'employee_attendance_status'"></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
    </b-card-group>
    
    <b-card-group class="mb-4">
      <b-card>
        <div class="h4 text-muted text-right mb-4">
          <i class="icon-people"></i>&nbsp;Karyawan Per-Divisi
        </div>
        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('doughnut-employee-division')"
            :doughnut-label="employee_division.label"
            :doughnut-data="employee_division.data"
            chartId="chart-doughnut-01"
          ></doughnut-example>
          <br />
          <table-total :tableData="employee_division" :title="'employee_division'"></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
      
      <b-card>
        <div class="h4 text-muted text-right mb-4">
          <i class="icon-people"></i>&nbsp;Karyawan Per-Office
        </div>
        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('employee-position')"
            :doughnut-label="employee_head_office.label"
            :doughnut-data="employee_head_office.data"
            chartId="employee-position-01"
          ></doughnut-example>
          <br />
          <table-total :tableData="employee_head_office" :title="'employee_head_office'"></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
      <b-card>
        <div class="h4 text-muted text-right mb-4">
          <i class="icon-people"></i>&nbsp;Karyawan Shifting
        </div>
        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('employee-shift-type')"
            :doughnut-label="employee_shift_type.label"
            :doughnut-data="employee_shift_type.data"
            chartId="employee-shift-type-01"
          ></doughnut-example>
          <br />
          <table-total :tableData="employee_shift_type" :title="'employee_shift_type'"></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
    </b-card-group>

  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import tableTotal from "@/templates/TableTotal.vue";
import VueNotifications from "vue-notifications";
import loading from "@/templates/Loading.vue";
import LineExample from "@/views/charts/LineExample.vue";
import DoughnutExample from "@/views/charts/DoughnutExample.vue";

import BarExample from "@/views/charts/BarExampleClick.vue";
import * as moment from "moment";

import _ from "lodash";
export default {
  name: "dashboard-hrd",
  components: {
    globalTable,
    Callout,
    loading,
    LineExample,
    DoughnutExample,
    BarExample,
    tableTotal
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      total_employee: [],
      employee_payment_method: [],
      employee_attendance: [],
      employee_attendance_verified: [],
      employee_contract: [],
      employee_attendance_status: [],
      employee_division: [],
      employee_head_office: [],
      employee_shift_type: [],
      loading: true,
      loadingAttendance: true,
      listMonth: [],
      listYear: [],
      listMonth2: [],
      listYear2: [],
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MM"),
      currentYear2: moment().format("YYYY"),
      currentMonth2: moment().format("MM"),

      fields_suggest_visit: [
        { key: "name", label: "Nama Konsumen", sortable: true },
        { key: "last_order_date", label: "Last Order", sortable: true }
      ],
      fields_myorder: [
        { key: "order_number", label: "Order Number", sortable: true },
        { key: "total_price_plan", label: "Total", sortable: true }
      ]
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  computed: {
    isMobile: function() {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      if(check === true) {
        if (window.screen.width < 732) {
          return undefined;
        } else {
          return 75;
        }
      } else {
        return 75;
      }
    }
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    init: function() {
      this.loading = true;
      
      let employee_id = localStorage.getItem("employee_id");
      this.axios
        .get("web/dashboard/all-dashboard-for-hrd/"+this.currentMonth+"/"+this.currentYear+"/")
        .then(response => {
          this.total_employee = response.data.total_employee;
          this.employee_payment_method = response.data.employee_payment_method;
          this.employee_attendance = response.data.employee_attendance;
          //let temp = [];
          //temp.push(response.data.employee_attendance.dataset);
          //this.employee_attendance.dataset = temp;
          this.employee_contract = response.data.employee_contract;
          this.employee_attendance_status = response.data.employee_attendance_status;
          this.employee_division = response.data.employee_division;
          this.employee_head_office = response.data.employee_head_office;
          this.employee_shift_type = response.data.employee_shift_type;
          this.listMonth = response.data.month;
          this.listYear = response.data.year;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    attendanceVerification: function() {
      this.loading = true;
      
      let employee_id = localStorage.getItem("employee_id");
      this.axios
        .get("web/dashboard/search-attendance-verification/"+this.currentMonth2+"/"+this.currentYear2+"/")
        .then(response => {
          this.employee_attendance_verified = response.data.employee_attendance_verified;
          this.listMonth2 = response.data.month;
          this.listYear2 = response.data.year;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    openVerificationDetail: function(e){
      //still not sucess
      //console.log(e);
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Konsumen",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
    this.attendanceVerification();
  }
};
</script>

<style>
</style>